import React from 'react'
import { Table } from 'react-bootstrap'

import BaseModal from 'shared/components/BaseModal'
import * as c from 'shared/constants'

const trackedEvents = [
  { event: 'page_view', intent: 'Which pages and routes users visit.', data: 'Page path, logged-in status, district geography, and property lookup BBL/BIN/tab when applicable' },
  { event: 'login / logout', intent: 'How often users sign in and out.', data: 'Logged-in status only (no email or username)' },
  { event: 'custom_search_submit', intent: 'Custom searches run and what they contain.', data: 'Search summary, geography, filter count' },
  { event: 'custom_search_save', intent: 'Saved, updated, or deleted custom searches.', data: 'Query name, action, notification frequency' },
  { event: 'custom_search_select_filter', intent: 'Which custom search filters are added.', data: 'Filter name' },
  { event: 'custom_search_switch_condition', intent: 'AND/OR condition usage in custom search.', data: 'Condition type' },
  { event: 'custom_search_add_group', intent: 'Use of nested condition groups.', data: 'Event only' },
  { event: 'custom_search_property_type', intent: 'Housing type selections in custom search.', data: 'Housing type value' },
  { event: 'district_dashboard_view', intent: 'District dashboard usage by geography.', data: 'Geography type, ID, label (Council District, Community District, State Assembly, State Senate, Zip Code), and logged-in status' },
  { event: 'district_dashboard_select_filter', intent: 'Dataset filter cards selected on the dashboard.', data: 'Filter name' },
  { event: 'district_dashboard_select_date', intent: 'Date range selections on the dashboard.', data: 'Date range value' },
  { event: 'district_dashboard_toggle_condition', intent: 'AND/OR toggle on dashboard results.', data: 'Condition type' },
  { event: 'property_lookup_view', intent: 'Property lookup usage.', data: 'BBL and optional BIN' },
  { event: 'property_lookup_search', intent: 'Address searches from the lookup bar.', data: 'Search text (truncated)' },
  { event: 'property_lookup_select_table', intent: 'Dataset tabs opened on a property.', data: 'Table name, tab id, resource type, BBL, and optional BIN' },
  { event: 'csv_download', intent: 'CSV exports from tables.', data: 'File name and feature area' },
  { event: 'table_column_filter / table_sort / table_filter_select', intent: 'Column filters, sorting, and header filter buttons.', data: 'Column or filter name' },
  { event: 'analytics_modal_open', intent: 'Users who read this analytics information.', data: 'Event only' },
]

const Component = props => {
  return (
    <BaseModal
      centered={true}
      labelId={props.labelId}
      modalFooter={props.modalFooter}
      hideModal={props.hideModal}
      show={props.show}
      size={props.size}
      title="Analytics"
    >
      <p className="text-dark">
        This site uses{' '}
        <a href="https://analytics.google.com" target="_blank" rel="noopener noreferrer">
          Google Analytics 4
        </a>{' '}
        to help us better understand how it's used.
      </p>
      <p>
        We've configured it to anonymize your IP address and not send personally identifiable information to Google,
        such as your email address, name, or username.
      </p>
      <p>
        Every event includes whether you are <strong>logged in</strong> or not, so we can understand authenticated vs.
        public usage without identifying you.
      </p>
      <p>
        We hope that collecting these analytics will help us make good decisions on how to improve the site for
        everyone.
      </p>
      <p>
        If you have any questions, feel free to reach out to{' '}
        <a href={`mailto:${c.CONTACT_EMAIL}`}>anhd.tech@gmail.com</a>
      </p>
      <p>
        The code for this website is open and available on{' '}
        <a href="https://github.com/ANHD-NYC-CODE/anhd-council-client" target="_blank" rel="noopener noreferrer">
          Github
        </a>
        .
      </p>
      <p>Here is a list of the GA4 events we currently track:</p>
      <Table bordered responsive size="sm">
        <thead>
          <tr>
            <th>Event</th>
            <th>Intent</th>
            <th>Data collected</th>
          </tr>
        </thead>
        <tbody>
          {trackedEvents.map(row => (
            <tr key={row.event}>
              <td>{row.event}</td>
              <td>{row.intent}</td>
              <td>{row.data}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </BaseModal>
  )
}

Component.propTypes = {}

export default Component
